import { useTranslation } from 'react-i18next';

import { EMPTY_FUNCTION } from '../../lib/globals';
import { getTestProps } from '../../lib/helpers';

import { CloseIcon } from '../../images/shapes';

import Avatar from '../Avatar/Avatar';

interface ImpersonateCardProps {
  /**
   * User initials
   */
  userInitials?: string;
  /**
   * User email
   */
  email?: string;
  /**
   * Callback to be called on closing the card
   */
  onClose?: () => void;
  /**
   * Component test id
   */
  testId?: string;
}

const ImpersonateCard = ({
  userInitials = '',
  email = '',
  onClose = EMPTY_FUNCTION,
  testId = '',
}: ImpersonateCardProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={
        `fixed top-2 left-1/2 -translate-x-1/2 z-50 w-fit bg-white dark:bg-slate-900 shadow-xl rounded-lg ` +
        `border border-red overflow-hidden`
      }
      {...getTestProps(testId)}
    >
      <div className="p-2">
        <div className="flex items-center gap-3">
          <Avatar userInitials={userInitials} testId={testId} />
          <div>
            <p className="text-sm dark:text-white">
              {t('Global.Impersonating')}
            </p>
            <p
              className="text-base text-black dark:text-white font-semibold"
              {...getTestProps(testId, 'email')}
            >
              {email}
            </p>
          </div>
          <div className="ml-4 shrink-0 flex self-start">
            <button
              type="button"
              className="inline-flex text-black focus:outline-hidden"
              onClick={onClose}
              {...getTestProps(testId, 'close')}
            >
              <CloseIcon className="w-3 dark:text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpersonateCard;
